import {
  CompaniesInfiniteSelectField,
  FloatingFormItem,
  InputDate,
} from '@/components/_common';
import { usePurchaseDownloadAllXml } from '@/core/domain/purchase/Purchase.hooks';
import {
  useDefaultEmptyFieldError,
  useDisclosure,
  useReportGenerate,
} from '@/hooks';
import { Button, Col, Form, Modal, Row } from 'antd';
import { Moment } from 'moment';

interface FormValues {
  companyId: number;
  startDate: Moment;
  endDate: Moment;
}

export default function PurchaseDownloadAllXml() {
  const [opened, action] = useDisclosure();
  const requiredField = useDefaultEmptyFieldError();

  const [form] = Form.useForm<FormValues>();
  const startDate = Form.useWatch('startDate', form);
  const endDate = Form.useWatch('endDate', form);

  const downloadAllXml = usePurchaseDownloadAllXml();

  const report = useReportGenerate();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      const startDate = values.startDate.format('YYYY-MM-DD');
      const endDate = values.endDate.format('YYYY-MM-DD');

      const result = await downloadAllXml.mutateAsync({
        companyId: values.companyId,
        startDate,
        endDate,
      });

      report.downloadFile({
        fileName: `xmls_${startDate}_${endDate}`,
        result,
        type: 'application/zip',
      });
    } catch {}
  };

  return (
    <>
      <Button onClick={action.open}>Baixar XMLs</Button>

      <Modal
        open={opened}
        onCancel={action.close}
        title="Filtrar e baixar arquivos XMLs"
        okText="Baixar XMLs"
        onOk={handleSubmit}
        confirmLoading={downloadAllXml.isLoading}
      >
        <p>
          Aplique os filtros para gerar e baixar um arquivo .zip contendo todos
          os XMLs das compras importadas dentro do período de emissão
          selecionada.
        </p>

        <Form form={form}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <FloatingFormItem
                name="companyId"
                label="Empresa"
                rules={[requiredField]}
              >
                <CompaniesInfiniteSelectField />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                name="startDate"
                label="Data de emissão inicial"
                rules={[requiredField]}
              >
                <InputDate disabledDate={(date) => date.isAfter(endDate)} />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                name="endDate"
                label="Data de emissão Final"
                rules={[requiredField]}
              >
                <InputDate disabledDate={(date) => date.isBefore(startDate)} />
              </FloatingFormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
